import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {Router, NavigationEnd} from "@angular/router";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

    constructor(private router: Router) {
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

}
